import React from "react";
import { Modal, Typography } from "antd";

const { Title, Text } = Typography;

const UserFormAnswerModal = ({ visible, onClose, data }) => {
    return (
        <Modal
            title={<Title level={4} style={{ margin: 0 }}>#{data?.id} Form Answers</Title>}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto", padding: '5px' }}
        >
            {/* <h4>User Name : {data?.user.name}</h4> */}
            {data?.user_form_ques?.length > 0 ? (
                data.user_form_ques.map((q, index) => (
                    <div
                        key={q.id}
                        style={{
                            background: "#f9fafb",
                            borderRadius: "8px",
                            padding: "16px 20px 5px",
                            marginBottom: "12px",
                            boxShadow: "0 2px 3px rgba(0,0,0,0.20)",
                        }}
                    >
                        <Text strong style={{ fontSize: "16px" }}>
                            {index + 1}. {q?.question_text}
                        </Text>
                        <div style={{ marginTop: "10px", paddingLeft: "12px" }}>
                            {q?.user_form_answ?.length > 0 ? (
                                <ul style={{ paddingLeft: "20px", margin: 0, listStyleType: "disc", listStylePosition: "outside" }}>
                                    {q.user_form_answ.map((ans) => (
                                        <li key={ans.id} style={{ marginBottom: "6px" }}>
                                            {ans.answer_text}
                                        </li>
                                    ))}
                                </ul>

                            ) : (
                                <Text type="secondary"><em>No answer submitted.</em></Text>
                            )}
                        </div>
                    </div>
                ))
            ) : (
                <Text>No questions available.</Text>
            )}
        </Modal>
    );
};

export default UserFormAnswerModal;
